import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

export function LanguageToggle() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || "tr").startsWith("en") ? "en" : "tr";

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={lang}
      onChange={(_, next) => {
        if (!next) return;
        void i18n.changeLanguage(next);
        localStorage.setItem("app-lang", next);
      }}
    >
      <ToggleButton value="tr">TR</ToggleButton>
      <ToggleButton value="en">EN</ToggleButton>
    </ToggleButtonGroup>
  );
}
